import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);

const DEFAULT_API_BASE_URL = 'https://kongjiangadmin.eyggs.top/api';

const SUPPORTED_LANGUAGES = new Set([
    'zh_cn',
    'en_us',
    'ms_my',
    'ko_hy',
    'es_spa',
    'yn_yu',
    'idn_yu',
    'ja_jp',
]);

const FALLBACK_MESSAGES = {
    zh_cn: '请求失败，请稍后重试',
    en_us: 'Request failed, please try again later',
    ms_my: 'Permintaan gagal, sila cuba lagi kemudian',
    ko_hy: '요청에 실패했습니다. 잠시 후 다시 시도해 주세요',
    es_spa: 'La solicitud fallo, intentelo de nuevo mas tarde',
    yn_yu: 'Yeu cau that bai, vui long thu lai sau',
    idn_yu: 'Permintaan gagal, silakan coba lagi nanti',
    ja_jp: 'リクエストに失敗しました。しばらくしてから再度お試しください',
};

function getCurrentLang() {
    const storedLang = localStorage.getItem('lang');

    if (storedLang && SUPPORTED_LANGUAGES.has(storedLang)) {
        return storedLang;
    }

    return 'ja_jp';
}

function getApiBaseURL() {
    if (process.env.VUE_APP_API_BASE_URL) {
        return process.env.VUE_APP_API_BASE_URL;
    }

    return DEFAULT_API_BASE_URL;
}

function normalizeApiMessage(result) {
    if (!result || typeof result !== 'object') {
        return FALLBACK_MESSAGES[getCurrentLang()] || FALLBACK_MESSAGES.ja_jp;
    }

    const rawMsg = result.msg != null ? String(result.msg).trim() : '';
    if (rawMsg) {
        return rawMsg;
    }

    const data = result.data;
    if (typeof data === 'string' && data.trim()) {
        return data.trim();
    }
    if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        const nestedMsg = data.msg != null ? String(data.msg).trim() : '';
        if (nestedMsg) {
            return nestedMsg;
        }
    }

    return FALLBACK_MESSAGES[getCurrentLang()] || FALLBACK_MESSAGES.ja_jp;
}

//创建axios实例对象
const  instance = axios.create({
    baseURL: getApiBaseURL(), // 服务器地址，优先读环境变量，否则固定到指定后台域名
    timeout: 5000, //默认超时时长
})

//请求拦截器
instance.interceptors.request.use(config=>{
    const headers = {...config.headers};

    if(config.method === "post"){
        headers['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; // 设置跨域头部
    }
    if(localStorage.getItem('token')){
        headers.token = Base64.encode(localStorage.getItem('token'));
    }
    const currentLang = getCurrentLang();
    headers.lang = currentLang;
    headers.lang2 = currentLang;
    config.headers = headers;
	
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    //此处对响应数据做处理
    if(res.data.msg === "鉴权错误"){
        localStorage.clear();
        this.$router.push({path:'/Login'})
    }
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    // 响应错误处理
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = JSON.parse(Base64.decode(result.data));
            result.msg = normalizeApiMessage(result);
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
                api[option.url],
            qs.stringify(option.data)
        ).then(res=>{
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
            result.msg = normalizeApiMessage(result);
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export default http

